/**
 * @licence Copyright © 2019 Mercury Redstone BV, all rights reserved
 */
import styled from 'styled-components';
import { TableCell } from './TableCell';
import { commonNumbersAligning } from './common';

export const TokenAmountCell = styled(TableCell)`
  ${commonNumbersAligning};
  width: 13%;
  min-width: 75px;
`;
